import React from 'react';
import { useSelector } from 'react-redux';
import { selectBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { getShowEarnAcceleratorBannerBehavior } from 'core/utils/earnAcceleratorBanner';

const EarnAcceleratorBannerComponent = React.lazy(() => import('component/common/EnterpriseWhiteLabel/EarnAcceleratorBanner'));

const LazyEarnAcceleratorBanner = () => {
    const behavior = useSelector(selectBehaviorFromBootstrap);
    const showEarnAcceleratorBanner = getShowEarnAcceleratorBannerBehavior(behavior);

    if (!showEarnAcceleratorBanner) return null;

    return (
        <div data-testid="lazy-earn-accelerator-banner-container">
            <React.Suspense fallback={null}>
                <EarnAcceleratorBannerComponent bannerVariant="default" />
            </React.Suspense>
        </div>
    );
};
LazyEarnAcceleratorBanner.displayName = 'LazyEarnAcceleratorBanner';

export default LazyEarnAcceleratorBanner;
